import { render } from "./CGUView.vue?vue&type=template&id=07fa88dc"
import script from "./CGUView.vue?vue&type=script&lang=js"
export * from "./CGUView.vue?vue&type=script&lang=js"

import "./CGUView.vue?vue&type=style&index=0&id=07fa88dc&lang=css"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__